import React from 'react';
import {
  Create,
  DateField,
  Filter,
  maxLength,
  minLength,
  NullableBooleanInput,
  NumberField,
  required,
  SearchInput,
  TextField,
  TextInput,
  UrlField,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import { ZippityDatagrid, ZippitySimpleForm } from '../components';
import ShortUrlField from './ShortUrlField';
import TextFieldWithPrependAppend from './TextFieldWithPrependAppend';
import ListWithCSVImport from '../components/ListWithCSVImport';

const ShortUrlFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <NullableBooleanInput source="was_clicked" defaultValue />
  </Filter>
);

const listStyles = {};

export const ShortUrlList = withStyles(listStyles)(({ classes, ...props }) => (
  <div>
    <ListWithCSVImport
      {...props}
      filters={<ShortUrlFilter />}
      bulkActionButtons={false}
      sort={{ field: 'key', order: 'ASC' }}
      perPage={50}
    >
      <ZippityDatagrid>
        <ShortUrlField source="short_url" />
        <UrlField source="redirect_url" />
        <TextField source="created_at" />
        <TextField source="modified_at" />
        <DateField source="first_clicked_at" showTime />
        <DateField source="latest_clicked_at" showTime />
        <TextFieldWithPrependAppend
          source="first_ip_address"
          displayAsLink
          prepend="http://ip-api.com/#"
        />
        <TextFieldWithPrependAppend
          source="latest_ip_address"
          displayAsLink
          prepend="http://ip-api.com/#"
        />
        <NumberField source="number_of_clicks" />
      </ZippityDatagrid>
    </ListWithCSVImport>

    <p>
      This allows customers to click a <strong>Short URL</strong>, which
      redirects them to the <strong>Long URL</strong>.
    </p>
    <p>It cannot be edited after creation.</p>
  </div>
));

const editStyles = { textInputWide: { width: '100%' } };

const validateUrl = [required(), minLength(2), maxLength(255)];

export const ShortUrlCreate = withStyles(editStyles)(
  ({ classes, ...props }) => (
    <Create {...props}>
      <ZippitySimpleForm>
        <TextInput
          validate={validateUrl}
          source="redirect_url"
          type="url"
          className={classes.textInputWide}
        />
      </ZippitySimpleForm>
    </Create>
  ),
);
